import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid2,
  IconButton,
  Modal,
  Paper,
  TextField,
  Typography,
  InputAdornment,
  useTheme,
} from "@mui/material";

import { HowToReg } from "@mui/icons-material";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useEffect, useState } from "react";
import api from "../../../../services/api";

import { LoadingButton } from "@mui/lab";
import { useNotification } from "../../../notificationProvider";

export default function PasswordModal(props) {
  const { openModal, setOpenModal, handleSynchronizeElements } = props;
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [loading, setLoading] = useState(false);

  const notify = useNotification();
  const theme = useTheme();
  const styles = {
    modal: { display: "flex", justifyContent: "center", alignItems: "center" },
    paper: {
      padding: 2,
      maxWidth: "432px",
      width: "90%",
      minWidth: "232px",
      maxHeight: "90vh",
      gap: 2,
      flexDirection: "column",
      display: "flex",
      alignItems: "felx-start",
      backgroundColor: theme.palette.background.paper,
    },
    subtitle: {
      fontSize: "14px",
      fontWeight: 500,
      color: "text.primary",
    },
    dialogActions: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "end",
      gap: 0,
      padding: 0,
      width: "100%",
    },
    dialogContent: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      padding: 0,
      gap: 1.5,
    },
    boxRowFields: {
      display: "flex",
      flexDirection: "column",
      with: "100%",
      gap: 1,
    },
    boxPasswords: {
      display: "flex",
      flexDirection: "column",
      with: "100%",
      gap: 2,
    },
    textfield: {
      maxWidth: "100%",
      mb: "10px",
      "& .MuiOutlinedInput-root": {
        backgroundColor: theme.palette.background.paperLinkedMaps,
        boxShadow: "none",
        "&:hover": {
          backgroundColor: theme.palette.background.paperLinkedMaps,
        },
      },
    },
    confirmButton: {
      color: theme?.palette?.color?.buttonConfirm || "primary.main",
    },
  };

  useEffect(() => {
    let loginStorage = JSON.parse(localStorage.getItem("login"));
    if (loginStorage) {
      setLogin(loginStorage);
    }
  }, []);

  async function handleApiCheckPassword() {
    setIsSubmit(true);

    if (!password || !login) return;
    try {
      setLoading(true);
      const response = await api.post("/checkPassword", {
        login: login,
        senha: password,
      });

      if (response) {
        handleClose();
        handleSynchronizeElements();
      }
    } catch (error) {
      notify(error.error || "Senha incorreta!", "error");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const handleClose = () => {
    setOpenModal(false);
    setPassword("");
    setShowPassword(false);
  };

  const handleClickShowPassword = (type) => {
    if (type === "password") {
      setShowPassword((show) => !show);
    }
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleApiCheckPassword();
    }
  };
  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={styles.modal}
    >
      <Paper sx={styles.paper}>
        <DialogTitle>Verificar senha</DialogTitle>
        <DialogContent sx={styles.dialogContent}>
          <Grid2 container columnSpacing={1.5} rowSpacing={2}>
            <Grid2 item size={{ xs: 12, sm: 12 }}>
              <Box sx={styles.boxRowFields}>
                <Typography sx={styles.subtitle}>Senha</Typography>{" "}
                <TextField
                  size="small"
                  id="input-senha"
                  type={showPassword ? "text" : "password"}
                  autoComplete="off"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Digite a senha"
                  sx={styles.textfield}
                  slotProps={{
                    input: {
                      autoComplete: "new-password",
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            edge="end"
                            onClick={() => handleClickShowPassword("password")}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                  onKeyDown={handleKeyDown}
                  error={isSubmit && !password}
                  helperText={isSubmit && !password && "A senha é obrigatória"}
                />
              </Box>
            </Grid2>
          </Grid2>
        </DialogContent>
        <DialogActions sx={styles.dialogActions}>
          <Button
            sx={{ color: "primary.main" }}
            onClick={handleClose}
            variant="text"
            disabled={loading}
          >
            Cancelar
          </Button>
          <LoadingButton
            onClick={handleApiCheckPassword}
            variant="text"
            sx={styles.confirmButton}
            loading={loading}
          >
            Salvar
          </LoadingButton>
        </DialogActions>
      </Paper>
    </Modal>
  );
}
